import {
  JACKET_V0_FORMULA_VERSION,
} from '@/lib/patterns/jacket/siy_v0';
import {
  JACKET_ACTIVE_FORMULA_VERSION,
  JACKET_V1_FORMULA_VERSION,
} from '@/lib/patterns/jacket/siy_v1';

export const JACKET_GEOMETRY_V0 = 'jacket_geom_v0';
export const JACKET_GEOMETRY_V1 = 'jacket_geom_v1';
export const JACKET_ACTIVE_GEOMETRY_VERSION = JACKET_GEOMETRY_V1;

export const JACKET_FORMULA_TO_GEOMETRY = {
  [JACKET_V0_FORMULA_VERSION]: JACKET_GEOMETRY_V0,
  [JACKET_V1_FORMULA_VERSION]: JACKET_GEOMETRY_V1,
};

export const JACKET_GEOMETRY_TO_FORMULA = {
  [JACKET_GEOMETRY_V0]: JACKET_V0_FORMULA_VERSION,
  [JACKET_GEOMETRY_V1]: JACKET_V1_FORMULA_VERSION,
};

export function normalizeJacketGeometryVersion(geometryVersion) {
  if (!geometryVersion) return JACKET_ACTIVE_GEOMETRY_VERSION;
  return geometryVersion === JACKET_GEOMETRY_V0 || geometryVersion === JACKET_GEOMETRY_V1
    ? geometryVersion
    : JACKET_ACTIVE_GEOMETRY_VERSION;
}

export function resolveJacketGeometryVersionFromFormula(formulaVersion) {
  return JACKET_FORMULA_TO_GEOMETRY[formulaVersion] || JACKET_ACTIVE_GEOMETRY_VERSION;
}

export function resolveJacketFormulaVersionFromGeometry(geometryVersion) {
  const normalizedGeometryVersion = normalizeJacketGeometryVersion(geometryVersion);
  return JACKET_GEOMETRY_TO_FORMULA[normalizedGeometryVersion] || JACKET_ACTIVE_FORMULA_VERSION;
}

export function migrateJacketPatternForward(patternLike = {}) {
  const explicitGeometry = String(patternLike?.geometry_version || '').toLowerCase();
  const explicitFormula = String(patternLike?.formula_version || '').toLowerCase();
  const normalizedGeometryVersion = explicitGeometry === JACKET_GEOMETRY_V0
    ? JACKET_GEOMETRY_V0
    : explicitGeometry === JACKET_GEOMETRY_V1
      ? JACKET_GEOMETRY_V1
      : explicitFormula === JACKET_V0_FORMULA_VERSION
        ? JACKET_GEOMETRY_V0
        : JACKET_ACTIVE_GEOMETRY_VERSION;
  return {
    ...patternLike,
    garment_type: patternLike?.garment_type || 'jacket',
    geometry_version: normalizedGeometryVersion,
    formula_version: resolveJacketFormulaVersionFromGeometry(normalizedGeometryVersion),
  };
}
